export const TicketModule = {
    namespaced: true,
    state: {
        ticketList: [],
        tableLoader: 1,
        totalRecord: 0,
        totalLenght: 0,
    }
}